import { StytchLoginForm } from "../navigation/StytchLoginForm";
import './styles/Login.css';

export const Registration = () => {
    return (
        <div className="jc-registration-container">
            <StytchLoginForm
                forNewAccount={true}
                disableFormToggle={true}
            />
        </div>
    )
};
